import React from 'react';

/** Gestion scénarios intégrée au layout panel (iframe legacy). */
const PanelInterventionsManageEmbedV1: React.FC = () => (
  <div className="overflow-hidden rounded-xl border border-[#243052]/90 bg-[#0d152b]/75 backdrop-blur-sm">
    <iframe title="Gestion scénarios" src="/panel/interventions/manage?embed=1" className="h-[78vh] w-full border-0" />
  </div>
);

export default PanelInterventionsManageEmbedV1;
